import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VRow,
    [
      _c(
        VCol,
        { attrs: { cols: "6" } },
        [
          _c(VSelect, {
            attrs: {
              outlined: "",
              items: _vm.currencyList,
              "item-text": "code",
              label: _vm.$t("currency"),
              "item-value": "o0301_id",
              rules: [(v) => !!v || _vm.$t("currencyRequired")],
            },
            model: {
              value: _vm.dValue.o0301_id,
              callback: function ($$v) {
                _vm.$set(_vm.dValue, "o0301_id", $$v)
              },
              expression: "dValue.o0301_id",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VCol,
        { attrs: { cols: "6" } },
        [
          _c("AtTextField", {
            attrs: {
              type: "number",
              disabled: !_vm.dValue.o0301_id,
              placeholder: "0.00",
              label: _vm.$t("amount"),
              hint:
                "1 " +
                _vm.code +
                " ≈ " +
                parseInt(1 / _vm.unitPrice) +
                " " +
                _vm.$t("components.TTCPriceField.coins"),
              rules: [
                (v) => !!v || _vm.$t("amountRequired"),
                (v) =>
                  v >= _vm.minPrice ||
                  _vm.$t("amountMin", { minPrice: _vm.minPrice }),
                // two decimal
                (v) =>
                  /^-?\d+(\.\d{1,2})?$/.test(v) ||
                  _vm.$t("amountDecimal", { minPrice: _vm.minPrice }),
              ],
              "persistent-hint": "",
              value: parseFloat(_vm.dValue.amount).toFixed(2),
            },
            on: {
              input: (v) => (_vm.dValue.amount = parseFloat(v).toFixed(2)),
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }